// extracted by mini-css-extract-plugin
export default {"wrapper":"PageHeader_wrapper__73HPx","title":"PageHeader_title__qKudp","subTitle":"PageHeader_subTitle__Z3Y3m","badge":"PageHeader_badge__LsQf7"};